import React, { useEffect } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import DashboardCards from "../components/DashboardCards/DashboardCards";
// unused icon imports removed
import "../styles/Dashboard.css";
import LineChartComponent from "../components/LineGraphComponent/LineChartComponent";
import BarChartComponent from "../components/GraphComponent/BarChartComponent";
import TableComponent from "../components/TableComponent/TableComponent";
import FarmerMap from "../components/FarmerMap/FarmerMap";
import TitleComponent from "../components/TitleComponent/TitleComponent";
import { ICONS } from "../constants/constants";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { handleUpdateUser } from "../store/actions/userActions";
import { handleGetAdminData, handleGetCompanyData } from "../store/actions/adminActions";
// getAdminIdFromToken removed (unused)
import Loader from "../assets/images/loader.gif";
const Dashboard = () => {
  // const { role } = getAdminIdFromToken();

  const { user } = useSelector((state) => state.user);
  const adminId = user?.id; // Assuming the adminId is stored in the user object
  const companyId = user?.company?.id;

  const dispatch = useDispatch();

  useEffect(() => {
    if (companyId && (user?.role === "admin" || user?.role === "manager")) {
      dispatch(handleGetCompanyData(companyId));
    } else if (adminId) {
      dispatch(handleGetAdminData(adminId));
    }
  }, [dispatch, adminId, companyId, user?.role]);

  // Access the adminData from the Redux store
  const { adminList, isLoading } = useSelector((state) => state.admin);

  // Safely log the adminData and adminUsers
  // useEffect(() => {
  //   if (adminData) {
  //     if (adminData?.adminUsers) {
  //     } else {
  //     }
  //   } else {
  //   }
  // }, [adminData]);

  // Support both admin/getadmindata and company/:id response shapes
  const companySource = adminList?.admin || adminList?.data?.company;
  const users = companySource?.adminUsers || companySource?.suppliers || adminList?.admin?.adminUsers || [];
  const farmers = users?.filter((u) => u.role === "farmer") || [];
  const suppliers = users?.filter((u) => u.role === "supplier") || [];
  const consultants = users?.filter((u) => u.role === "consultant") || [];
  const farmerdata = users;

  const [selectedType, setSelectedType] = useState("farmer");

  // Convert budgetPerAcre to a number
  const budgetPerAcre =
    parseFloat(adminList?.shiriahBudget?.[0]?.budgetPerAcre) || 0;

  let totalBudget = 0; // Initialize total budget separately

  // Calculate total budget for each farmer
  const farmersWithBudget = farmers?.map((farmer) => {
    let farmerBudget = 0;

    if (farmer.farmDetails?.length > 0) {
      farmerBudget = farmer.farmDetails.reduce((sum, farm) => {
        const farmArea = parseFloat(farm.farm_area) || 0; // Convert farm_area to number safely
        return sum + farmArea * budgetPerAcre;
      }, 0);
    }

    totalBudget += farmerBudget; // Accumulate total budget separately

    return { ...farmer, farmerBudget }; // Store farmer's budget separately
  });

  // Output results

  const barChartData = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [
      {
        label: "2024",
        data: [12, 19, 3, 5, 2, 3, 7],
        backgroundColor: "rgba(75, 192, 192, 0.6)",
      },
      {
        label: "2023",
        data: [10, 14, 5, 2, 20, 30, 45],
        backgroundColor: "rgba(255, 159, 64, 0.6)",
      },
    ],
  };

  const lineChartData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
    datasets: [
      {
        label: "Budget",
        data: [30, 45, 28, 50, 42, 56, 40, 55, 30],
        borderColor: "rgba(75, 192, 192, 1)",
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        tension: 0.4,
      },
      {
        label: "Return",
        data: [20, 35, 25, 45, 35, 50, 38, 48, 25],
        borderColor: "rgba(255, 159, 64, 1)",
        backgroundColor: "rgba(255, 159, 64, 0.2)",
        tension: 0.4,
      },
      {
        label: "Earn",
        data: [25, 40, 22, 48, 38, 52, 33, 50, 28],
        borderColor: "rgba(153, 102, 255, 1)",
        backgroundColor: "rgba(153, 102, 255, 0.2)",
        tension: 0.4,
      },
    ],
  };

  // (approveSupplier handled elsewhere if needed)

  const tableTitle = user?.role === "manager" ? "Users" : "Farmers";

  // Prepare data for TableComponent (support manager view with tags)
  const buildRow = (u) => ({
    Name: u?.name,
    Mobile: u?.mobile_number || "N/A",
    CNIC: u?.cnic,
    Status: u?.account_status,
    Actions:
      user?.role === "manager" ? (
        <>
          <Link to={`/${u.role}/${u.id}`} state={{ [u.role]: u }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" style={{ opacity: 0.5, pointerEvents: "none" }} />
        </>
      ) : u?.account_status === "Approved" ? (
        <>
          <Link to={`/${u.role}/${u.id}`} state={{ [u.role]: u }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
          <img src={ICONS.downloadIcon} alt="Download" className="cross-icon" />
        </>
      ) : (
        <>
          <Link to={`/${u.role}/${u.id}`} state={{ [u.role]: u }} rel="noopener noreferrer">
            <img src={ICONS.viewIcon} alt="View" className="tick-icon" />
          </Link>
        </>
      ),
  });

  let data = [];
  if (user?.role === "manager") {
    if (selectedType === "farmer") data = farmers.filter((f) => f.account_status === "Approved").map(buildRow);
    if (selectedType === "supplier") data = suppliers.filter((s) => s.account_status === "Approved").map(buildRow);
    if (selectedType === "consultant") data = consultants.filter((c) => c.account_status === "Approved").map(buildRow);
  } else {
    data = farmers.map(buildRow);
  }

  const columns = ["Name", user?.role !== "manager" ? "Email" : "", user?.role !== "manager" ? "Mobile" : "", user?.role !== "manager" ? "CNIC" : "", "Actions"];

  // Pass dynamically if these features should be shown
  const showSearchBar = true; // Change to false to hide search bar
  const searchplaceholder = "Search by Farmer’s Name, CNIC, Crop";
  const showFilter = false; // Change to false to hide filter
  const showTabs = true; // Change to false to hide tabs (Approved/Not Approved)
  const showColors = true;
console.log('companySource',companySource);
  const getCountByRole = (role) => {
    const users = companySource?.suppliers || adminList?.admin?.adminUsers || [];
    return users.filter((user) => user.role === role).length;
  };

  const cardData = [
    ...(user?.role !== "manager"
      ? [
          {
            title: "Shariah Budget",
            value: `${totalBudget} PKR`,
            colorKey: "budget",
            imageKey: "budgetIcon",
          },
        ]
      : []),
  
    {
      title: "No of Farmers",
      value: `${getCountByRole("farmer")}`,
      colorKey: "farmer",
      imageKey: "farmerIcon",
    },
    {
      title: "No of Suppliers",
      value: `${getCountByRole("supplier")}`,
      colorKey: "supplier",
      imageKey: "supplierIcon",
    },
    {
      title: "No of Consultants",
      value: `${getCountByRole("consultant")}`,
      colorKey: "consultant",
      imageKey: "consultantIcon",
    },
  ];
  
  if (isLoading) {
    return (
      <div className="loaderOverlay">
        <img src={Loader} alt="Loader" />
      </div>
    );
  }

  return (
    <Container>
      <Row>
        <Col lg={12} className="component-container">
          <TitleComponent title="Dashboard" className="dasboardTitle" />
          <DashboardCards cardData={cardData} />
        </Col>
      </Row>
      <Row className="d-flex justify-content-between two-columns">
        <Col md={6} className="component-container">
          <TitleComponent title="Productions Details" />
          <BarChartComponent data={barChartData} />
        </Col>
        <Col md={6} className="component-container right mb-2 ms-1">
          <TitleComponent title={user?.role === "manager" ? "Map" : "Finance"} />
          {user?.role === "manager" ? <FarmerMap /> : <LineChartComponent data={lineChartData} />}
        </Col>
      </Row>

      <Row>
        <Col lg={12} className="component-container mb-2">
          {user?.role === "manager" && (
            <Nav variant="tabs" activeKey={selectedType} onSelect={(k) => setSelectedType(k)}>
              <Nav.Item>
                <Nav.Link eventKey="farmer">Farmers</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="supplier">Suppliers</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="consultant">Consultants</Nav.Link>
              </Nav.Item>
            </Nav>
          )}

          <TableComponent
            columns={columns}
            data={data}
            title={tableTitle}
            showSearchBar={showSearchBar}
            searchplaceholder={searchplaceholder}
            showFilter={showFilter}
            showTabs={showTabs && user?.role !== "manager"}
            showColors={showColors}
            showCount={false}
            onEdit={false}
            onDelete={false}
            onDownload={false}
            showAddNewAdmin={false}
            customClass="ms-3"
            showRating={false}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
